import { Typography } from "components";
import React from "react";
import { ROUTES } from "../../routes/routePaths";
import { useNavigate } from "react-router-dom";
import pocketMoniLogo from "../../assets/images/pocketmoni-logo.png";
import successImg from "../../assets/images/success-image.png";
import { pocketMoniUrl } from "../../routes/routePaths";
import "./style.scss";

const PasswordSetSuccess = () => {
  const navigate = useNavigate();
  return (
    <div style={{ backgroundColor: "#FCFDFF", height: "100vh" }}>
      <div className="password-reset-header">
        <a href={pocketMoniUrl} target="_blank" rel="noopener noreferrer">
          <img src={pocketMoniLogo} width="100" alt="PocketMoni" />
        </a>
      </div>
      <div className="password-success-container mx-auto text-center">
        <img src={successImg} alt="" width="100" />
        <Typography
          variant="subtitle3"
          component="h4"
          className="mt-4"
          state="primary"
        >
          Password Successfully set!
        </Typography>
        <Typography variant="caption1" state="primary" className="my-3">
          Your password has been set. Click{" "}
          <Typography
            className="login-cta"
            state="secondary"
            onClick={() => navigate(ROUTES.login)}
          >
            here
          </Typography>{" "}
          to login to your account.
        </Typography>
      </div>
    </div>
  );
};

export default PasswordSetSuccess;
